const fields = [
  {
    key: 'minFreeAgentsPlayers',
    type: 'input',
    templateOptions: {
      attrs: { type: 'number' },
      label: 'minFreeAgentsPlayers'
    },
    display: (field, model) => model.freeAgentApplicationEnabled
  },
  {
    key: 'maxFreeAgentPlayers',
    type: 'input',
    templateOptions: {
      attrs: { type: 'number' },
      label: 'maxFreeAgentPlayers'
    },
    display: (field, model) => model.freeAgentApplicationEnabled
  }
]

export default fields
